import React, { useEffect } from 'react';
import EmptyGradientBackground from './components/EmptyGradientBackground';

const newHost = 'https://gusaguiar.com'; // Define tu host de destino
const newQueryParamName = 'from_redirect'; // Nombre del nuevo parámetro
const newQueryParamValue = 'simeditamos'; // Valor del nuevo parámetro

function App() {
  useEffect(() => {
    if (window.location.pathname.indexOf('seguroparaviaje') !== -1) {
      // Si estamos en localhost, no hacemos nada
      return;
    }
    if (window.location.pathname.indexOf('spv') !== -1) {
      // Si estamos en localhost, no hacemos nada
      return;
    }
    
    // Solo redirige si no estamos ya en el host de destino
    if (window.location.hostname !== newHost.replace(/^(https?:\/\/(www\.)?)/, '')) {
      const currentPath = window.location.pathname;
      let queryString = window.location.search; // Obtiene la cadena de consulta existente

      // 1. Prepara el nuevo parámetro a añadir
      const paramToAdd = `${newQueryParamName}=${newQueryParamValue}`;

      // 2. Comprueba si el nuevo parámetro ya existe en la cadena de consulta
      // Esto evita duplicados si por alguna razón el parámetro ya viene en la URL
      if (queryString.includes(`${newQueryParamName}=`)) {
          // Si el parámetro ya existe, puedes decidir si reemplazarlo o no.
          // Para este ejemplo, lo reemplazaremos para asegurar el valor deseado.
          // Se usa una expresión regular para manejar casos como ?source=old&other=val o &source=old
          queryString = queryString.replace(new RegExp(`([?&])${newQueryParamName}=[^&]*`), `$1${paramToAdd}`);
      } else {
          // Si no existe, lo añade
          if (queryString === '') {
            // Si no hay cadena de consulta existente, empieza con '?'
            queryString = `?${paramToAdd}`;
          } else {
            // Si ya hay una cadena de consulta, añade con '&'
            queryString = `${queryString}&${paramToAdd}`;
          }
      }

      // Construye la nueva URL de redirección
      const redirectUrl = `${newHost}${currentPath}${queryString}`;

      // Realiza la redirección
      window.location.replace(redirectUrl);
    }
  }, []); // El array vacío asegura que se ejecute solo una vez al montar el componente

  // Puedes renderizar un mensaje de "Redirigiendo..." mientras ocurre la redirección
  return (
    <EmptyGradientBackground />
  );
}

export default App;